import React from 'react';
import { X } from 'lucide-react';
import { InfoRow } from '../ui/InfoRow';

export interface MarketDataOverlayProps { [key: string]: any; }

export const MarketDataOverlay: React.FC<MarketDataOverlayProps> = ({
  showMobileData,
  setShowMobileData,
  isTutorialMode,
  currentPrice,
  periodHigh,
  periodLow,
  periodChange,
  dataToRender,
  timeframe,
  timeframeNames,
  colorUp,
  colorDown,
}) => {
  if (!showMobileData || isTutorialMode) return null;

  return (
    <div 
      className="fixed inset-0 z-[150] bg-black/40 backdrop-blur-sm flex items-center justify-center p-4 md:p-6"
      onClick={() => setShowMobileData(false)}
    >
      <div 
        className="bg-[#0a0e27]/90 backdrop-blur-md border border-[#00d9ff]/30 p-5 rounded-lg w-full max-w-[280px] shadow-[0_10px_40px_rgba(0,217,255,0.15)] animate-in fade-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-3 md:mb-4">
          <h2 className="text-[10px] md:text-[11px] uppercase tracking-[2px] text-[#00d9ff]">Market Data</h2>
          <button onClick={() => setShowMobileData(false)} className="text-[#00d9ff]"><X size={16} /></button>
        </div>
        <div className="space-y-3 md:space-y-4">
          <InfoRow 
            label="Preço Atual" 
            value={
              <div className="flex flex-wrap items-center justify-end">
                <span>{"$" + currentPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
            } 
          />
          <InfoRow label="Máxima (Alta)" value={"$" + periodHigh.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} />
          <InfoRow label="Mínima (Baixa)" value={"$" + periodLow.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} />
          <InfoRow label="Mudança" value={periodChange.toFixed(2) + "%"} color={periodChange >= 0 ? colorUp : colorDown} />
          <InfoRow label="Resolução" value={dataToRender.length.toLocaleString('en-US') + " pts"} />
          <InfoRow label="Fractal" value={timeframeNames[timeframe] || timeframe} shrink />
        </div>
      </div>
    </div>
  );
};
